module.exports = __webpack_public_path__ + "static/media/plane-departure.0834f737.svg";